<div class="bg-container" ngClass.xs="handset" ngClass.md="md">
  <div class="bg" ngClass.xs="handset" ngClass.md="md">
    <router-outlet ngClass.xs="xs"></router-outlet>
  </div>
</div>
